import HodlPage from './Page'

export default HodlPage
